export const blackRockBlue = "hsl(239, 43%, 41%)";
export const blackRockBlueWithLightness = (percentage: number) =>
	`hsl(239, 43%, ${percentage}%)`;
export const blackRockBlueWithAlpha = (percentage: number) =>
	`hsl(239, 43%, 41%, ${percentage}%)`;
